import React, { useContext, useEffect, useState } from 'react';
import ConsultationCard from '../../components/ConsultationCard/ConsultationCard';
import {
    getAppointmentHistory,
    getUserApi,
} from '../../apis';
import MobileProfileTopNavigation from '../../Pages/MobileProfileLayout/MobileProfileTopNavigation';
import { ProfileSliderContext } from '../../appContext';
import ViewDetails from '../../components/ConsultationCard/ViewDetails';
import useDeviceType from '../../utils/useDeviceType';
import NoConsultation from '../../lottiefiles/no_consultation.json'
import Placeholder from '../../components/placeholder';

export default function AppointmentHistorySection({ handleviewreqdesktop }) {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
     const [ViewRequestBlock, setViewRequestBlock] = useState(false);
    const [appointmentHistoryData, setAppointmentHistoryData] = useState(null);
    const [filterHistory, setFilterHistory] = useState('yearly'); //weekly  monthly  yearly
    const [doctorProfileId, setDoctorProfileId] = useState(null);
        const [currentrequest, setcurrentrequest] = useState(null);
    const toGetAppointmentHistory = async (id) => {
        try {
            const res = await getAppointmentHistory(id);
            console.log(res);
            if (res.status === 200) {
                console.log(res.data.AppointmentHistory);
                setAppointmentHistoryData(res.data?.AppointmentHistory);
            }
        } catch (error) {
            console.log(error);
        }
    };
    const fetchData = async () => {
        try {
            const res = await getUserApi();
            if (res.status === 200) {
                console.log('profile id', res?.data?.Profile?._id);
                setDoctorProfileId(res?.data?.Profile?.DoctorProfile?._id);
                toGetAppointmentHistory(res?.data?.Profile?.DoctorProfile?._id);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);
    const handleHistoryFilter = (event) => {
        const value = event.target.value;
        toGetAppointmentHistory(`${doctorProfileId}&filter=${value}`);
        setFilterHistory(value);
    };
    function handelViewRequestBlockMob(data) {
        setViewRequestBlock(!ViewRequestBlock);
        setcurrentrequest(data?._id);
    }
     const deviceType = useDeviceType();
    return (
        <>
            <div className='pt-[20%] md:pt-[10%] px-6 bg-white h-[100vh] w-[100vw] lg:pt-[0px] lg:px-0 lg:h-[auto] lg:w-[auto] custom_pt_md-lg'>
                <div className="flex items-center flex-wrap gap-4 my-5 lg:hidden">
                    {/* <MobileProfileTopNavigation pageTitle={'Appointment History'} /> */}
                    <select
                        name="report"
                        className=" bg-accent text-white px-4 py-2 rounded-[4px]  capitalize ms-auto baseText w-full lg:w-auto"
                        onChange={handleHistoryFilter}
                        value={filterHistory}
                    >
                        <option
                            className="text-coalBlack bg-white font-medium text-sm whitespace-nowrap"
                            value={'weekly'}
                        >
                            {' '}
                            Weekly report
                        </option>
                        <option
                            className="text-coalBlack bg-white font-medium text-sm whitespace-nowrap"
                            value={'monthly'}
                        >
                            Monthly report
                        </option>
                        <option
                            className="text-coalBlack bg-white font-medium text-sm whitespace-nowrap"
                            value={'yearly'}
                        >
                            Yearly report
                        </option>
                    </select>
                </div>
                <div className="items-center flex-wrap gap-4 mb-7 hidden lg:flex">
                    <select
                        name="report"
                        className=" bg-accent text-white px-4 py-2 rounded-[4px]  capitalize ms-auto baseText w-full lg:w-auto"
                        onChange={handleHistoryFilter}
                        value={filterHistory}
                    >
                        <option
                            className="text-coalBlack bg-white font-medium text-sm whitespace-nowrap"
                            value={'weekly'}
                        >
                            {' '}
                            Weekly report
                        </option>
                        <option
                            className="text-coalBlack bg-white font-medium text-sm whitespace-nowrap"
                            value={'monthly'}
                        >
                            Monthly report
                        </option>
                        <option
                            className="text-coalBlack bg-white font-medium text-sm whitespace-nowrap"
                            value={'yearly'}
                        >
                            Yearly report
                        </option>
                    </select>
                </div>
               
                    {appointmentHistoryData?.length !== 0 ? (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-8 pb-[25%]">
    {appointmentHistoryData?.map((data, key) => (
      <div key={key}>
        <ConsultationCard
          fillBtnTitle="View Detail"
          data={data}
          ViewRequest={() => {
            if (deviceType === 'Mobile' || deviceType === 'Tablet') {
              handelViewRequestBlockMob(data);
            } else {
              handleviewreqdesktop(data);
            }
          }}
          fillBtnfun={() => {
            if (deviceType === 'Mobile' || deviceType === 'Tablet') {
              handelViewRequestBlockMob(data);
            } else {
              handleviewreqdesktop(data);
            }
          }}
          showDeleteBtn={false}
        />
      </div>
    ))}
  </div>
) : (
  <Placeholder
    title="No Consultations found."
    animationData={NoConsultation}
    height={200}
    message="No consultation requests were found at the moment."
  />
)}

          
            </div>
            {ViewRequestBlock && (
                <ViewDetails
                    closeFunction={() => {
                        if (deviceType == 'Mobile' || deviceType == 'Tablet') {
                            handelViewRequestBlockMob()
                        }
                        else {
                            handleviewreqdesktop()
                        }
                    }}
                    currentdata={currentrequest}
                />
            )}
        </>
    )
}